import { createContext, useContext } from "react";
import en from "./en";
import ja from "./ja";

export const LOCALES = ["en", "ja"];
export const STORAGE_KEY = "ht_locale";
const dictionaries = { en, ja };

export const LocaleContext = createContext("en");
export const useLocale = () => useContext(LocaleContext);

export const useT = () => {
  const lang = useLocale();
  return (path) => path.split(".").reduce((o, k) => (o == null ? o : o[k]), dictionaries[lang]) ?? path;
};

export const localePath = (lang, path = "") => `/${lang}${path ? `/${path.replace(/^\//, "")}` : ""}`;

export const useLocalePath = () => {
  const lang = useLocale();
  return (path = "") => localePath(lang, path);
};

export const detectLocale = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (LOCALES.includes(saved)) return saved;
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language || ""];
  return langs[0]?.toLowerCase().startsWith("ja") ? "ja" : "en";
};

export const swapLocale = (pathname, target) =>
  LOCALES.some((l) => pathname === `/${l}` || pathname.startsWith(`/${l}/`))
    ? pathname.replace(/^\/(en|ja)/, `/${target}`)
    : `/${target}`;
